import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SplitButton } from '@shared/ui/buttons';
import { useCreateTeamDialog } from '@utils/dialogs-hooks';
import { EditTeamMenu } from '@widgets/teams/menu';

export default function EditTeamDisplay() {
  const { t } = useTranslation();
  const { openCreateTeamDialog } = useCreateTeamDialog();
  const { group } = useSelector((state) => state.group_id);

  return (
    <SplitButton
      text={t('edit_team')}
      icon="edit"
      action={() => openCreateTeamDialog(group)}
      menuComponent={EditTeamMenu}
      menuProps={{ data: group }}
    />
  );
}
